
import Bugsnag from '@bugsnag/js';
import Multiselect from '~/patterns/atoms/multiselect/multiselect.vue';
import GwIcon from '~/patterns/atoms/icon/icon.vue';

export default {
    components: {
        Multiselect,
        GwIcon
    },
    props: {
        validator: {
            type: Object,
            default: undefined
        },
        state: {
            type: Object,
            default: null
        },
        countryCode: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            options: [],
            selectedState: null
        };
    },
    watch: {
        selectedState(payload) {
            this.$emit('stateChanged', payload);
        },
        state(state) {
            if (!state && this.selectedState !== null) {
                this.selectedState = null;
            }
        },
        countryCode() {
            this.selectedState = null;
            this.getStates();
        }
    },
    mounted() {
        this.getStates();
    },
    methods: {
        getFlagEmoji(countryCode) {
            const codePoints = countryCode
                .toUpperCase()
                .split('')
                .map(char => 127397 + char.charCodeAt());
            return String.fromCodePoint(...codePoints);
        },
        async getStates() {
            this.options = [];
            try {
                await this.$axios.get(this.$config.apiUrl + `/api/countries/states?country=${this.countryCode}`)
                    .then((response) => {
                        this.options = response.data;
                    });
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);

                Bugsnag.notify(error);
            }
        }
    }
};
